import { AppShellViewModel } from "../viewmodels/AppShellViewModel.js";
import { useSingleton } from "mvc-kit/react";
//#region src/modules/AppWrapper2/hooks/useAppInteractionHandlers.ts
function useAppInteractionHandlers() {
	return useSingleton(AppShellViewModel).state.appInteractionHandlers;
}
//#endregion
export { useAppInteractionHandlers };

//# sourceMappingURL=useAppInteractionHandlers.js.map